import { render, staticRenderFns } from "./ReportPostsModal.vue?vue&type=template&id=5882ba00&scoped=true&"
import script from "./ReportPostsModal.vue?vue&type=script&lang=js&"
export * from "./ReportPostsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5882ba00",
  null
  
)

export default component.exports